import moment from "moment";
import { composeContainers } from "@/utils/composeContainers";
import { ComponentChecker } from "../PageBySlug/components/ComponentChecker/ComponentChecker";
import { BlogCategories } from "../Blog/components/BlogCategories";
import { ViewProps } from "./types";
import BlogPostSummary from "./BlogPostSummary/BlogPostSummary";
import { LFooter } from "@/components";
import Image from "next/image";
export default composeContainers<ViewProps>({
  containers: [],
  component: ({
    categories,
    blogData,
    components,
    summaryTitles,
    readingTime,
    footerComponent,
  }: ViewProps) => (
    <>
      <article className="max-w-5xl mx-auto px-4 py-6 space-y-6 web-landing-v2 scroll-smooth">
        {categories && <BlogCategories categories={categories} isSinglePost />}

        {/* Main Content */}
        <div className="space-y-4">
          <h1 className="text-3xl md:text-5xl font-bold leading-tight">
            {blogData?.attributes?.title}
          </h1>
        </div>

        {/* Author Info */}
        <div className="flex flex-wrap items-center gap-4 py-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="relative">
              {blogData?.attributes?.author_image?.data?.attributes?.url && (
                <Image
                  src={
                    blogData?.attributes?.author_image?.data?.attributes?.url
                  }
                  alt="Author"
                  className="w-16 h-16 rounded-full object-cover"
                  fill
                  sizes="(max-width: 768px) 100vw, 33vw"
                  quality={80}
                />
              )}
            </div>

            <div className="space-y-1">
              <div className="text-xl font-bold">
                {blogData?.attributes?.author?.data?.attributes?.firstName}{" "}
                {blogData?.attributes?.author?.data?.attributes?.lastName}
              </div>
              <div className="text-sm text-gray-500 flex items-center gap-2">
                <span>
                  {moment(blogData?.attributes?.publishedAt)
                    ?.locale("ro")
                    ?.format("LL")}
                </span>
                <span>·</span>
                <span>{readingTime} min read</span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full aspect-video relative rounded-lg overflow-hidden">
          {blogData?.attributes?.media?.data?.[0]?.attributes?.url && (
            <Image
              src={blogData?.attributes?.media?.data?.[0]?.attributes?.url}
              className="w-full h-full object-cover"
              alt={
                blogData?.attributes?.media?.data?.[0]?.attributes
                  ?.alternativeText || ""
              }
              fill
              sizes="(max-width: 768px) 100vw, 33vw"
              quality={80}
            />
          )}
        </div>

        <p className="text-gray-600 text-lg md:text-xl mt-4">
          {blogData?.attributes?.info_text}
        </p>

        {summaryTitles && <BlogPostSummary summaryTitles={summaryTitles} />}
      </article>
      <div className="lg:max-w-5xl mx-auto">
        {components?.map((component, key) => (
          <ComponentChecker component={component} key={key} />
        ))}
      </div>
      <>
        <LFooter
          id={footerComponent?.id}
          leftText={footerComponent?.leftText}
          rightText={footerComponent?.rightText || ""}
          bottomContent={footerComponent?.bottomContent || ""}
          iconColumnTitle={footerComponent?.iconColumnTitle || ""}
          linkWithIcon={
            footerComponent?.iconLinks?.map((iconLink) => ({
              iconName: iconLink?.iconName,
              text: iconLink?.text,
              link: iconLink?.link,
            })) as {
              iconName?: string;
              text?: string;
              link?: string;
            }[]
          }
          column={
            footerComponent?.columns?.map((column) => ({
              title: column?.title,
              content: column?.content,
            })) as {
              title?: string;
              content?: string; //rich text
            }[]
          }
        />
      </>
    </>
  ),
});
